<template>
  <div class="VacationDetails">
    <div v-if="list.length > 0">
      <vacation-details-list-web :list="list" class="hidden-sm-and-down" />
      <vacation-details-list-mob :list="list" class="hidden-md-and-up" />
    </div>
    <div v-else>
      <EmptyList />
    </div>
    <box
      v-if="vacationRemain.SahmieMorakhasi"
      :title="$t('vacationRemain.title')"
      class="ma-2"
    >
      <div class="pa-2">
        <v-row>
          <v-col cols="6"
            >{{ $t("vacationRemain.SahmieMorakhasi") }}:<span
              class="text-value"
              >{{ vacationRemain.SahmieMorakhasi }}</span
            ></v-col
          >
          <v-col cols="6"
            >{{ $t("vacationRemain.MandeAzSaleGhabl") }}:<span
              class="text-value"
              >{{ vacationRemain.MandeAzSaleGhabl }}</span
            ></v-col
          >
          <v-col cols="6"
            >{{ $t("vacationRemain.morakhasiEstefadeshode") }}:<span
              class="text-value"
              >{{ vacationRemain.morakhasiEstefadeshode }}</span
            ></v-col
          >
          <v-col cols="6"
            >{{ $t("vacationRemain.MandeAzMaheGhabl") }}:<span
              class="text-value"
              >{{ vacationRemain.MandeAzMaheGhabl }}</span
            ></v-col
          >
          <v-col cols="6"
            >{{ $t("vacationRemain.afzayeshemorakhasi") }}:<span
              class="text-value"
              >{{ vacationRemain.afzayeshemorakhasi }}</span
            ></v-col
          >
          <v-col cols="6"
            >{{ $t("vacationRemain.MandeTakonon") }}:<span class="text-value">{{
              vacationRemain.MandeTakonon
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("vacationRemain.kasremorakhasi") }}:<span
              class="text-value"
              >{{ vacationRemain.kasremorakhasi }}</span
            ></v-col
          >
          <v-col cols="6"
            >{{ $t("vacationRemain.MandeTapayanSal") }}:<span
              class="text-value"
              >{{ vacationRemain.MandeTapayanSal }}</span
            ></v-col
          >
        </v-row>
      </div>
    </box>
  </div>
</template>

<script>
import VacationDetailsListWeb from "../VacationDetails/VacationDetailsListWeb.vue";
import VacationDetailsListMob from "./VacationDetailsListMob.vue";
import TextUtils from "../../../../utils/TextUtils";
export default {
  components: {
    VacationDetailsListWeb,
    VacationDetailsListMob,
  },
  props: {
    args: Object,
  },
  mounted() {
    this.GetTotalVacationRemainDetail();
    this.GetVacationRemainDetail();
  },
  data() {
    return {
      list: [],
      vacationRemain: {},
    };
  },
  methods: {
    GetTotalVacationRemainDetail() {
      const params = new URLSearchParams();
      params.append("period", this.args.period);
      params.append("year", this.args.year);
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }

      this.$store
        .dispatch("GetTotalVacationRemainDetail", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.list = result.data.Table;
          }
        });
    },
    GetVacationRemainDetail() {
      const params = new URLSearchParams();
      params.append("period", this.args.period);
      params.append("year", this.args.year);
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }

      this.$store
        .dispatch("GetVacationRemainDetail", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.vacationRemain = result.data;
          }
        });
    },
    GetTotalVacationRemainDetailWithPrarm(item) {
      const params = new URLSearchParams();
      params.append("period", item.MMonth);
      params.append("year", item.year);
      if (item.PERNO) {
        params.append("perno",TextUtils.convertToEnglishDigits(item.PERNO));
      }

      this.$store
        .dispatch("GetTotalVacationRemainDetail", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.list = result.data.Table;
          }
          else{
            this.list=[]
          }
          this.$store
        .dispatch("GetVacationRemainDetail", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.vacationRemain = result.data;
          }
          else{
            this.vacationRemain=[]
          }
        });
        });
    },
   
  },
};
</script>

<style>
</style>